const url = {
  SECURITY: window.runtimeConfig.authWebSite,
  SECURITY_API_SERVER: window.runtimeConfig.authApiUrl,
  SECURITY_FIDO_API_SERVER: window.runtimeConfig.fidoApiUrl,
  API_SERVER: window.runtimeConfig.authApiUrl,
  NEWTUBE_API_SERVER: window.runtimeConfig.fdApiUrl,
  PY_API_SERVER: window.runtimeConfig.pyApiUrl,
  PT_API_SERVER: window.runtimeConfig.ptApiUrl,
  // 檔期津貼 BonusCalc 站台（OPTI-142）。各環境值由 runtime-config.js 提供：
  // TST https://tst-asia-bonus-calc.mayohr.com／UAT https://uat-asia-bonus-calc.mayohr.com
  // PP  https://preprd-asia-bonus-calc.mayohr.com／PRD https://bonus-calc.mayohr.com
  // 未設定時為 undefined，點擊 icon 會顯示錯誤訊息而非開啟空白頁。
  BONUS_CALC_WEBSITE: window.runtimeConfig.bonusCalcUrl,
};
export default url;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/url.js
 **/